import asyncActionType from "../../utils/asyncActionType";

export const FETCH_PURCHASE_ORDERS = asyncActionType("FETCH_PURCHASE_ORDERS");
export const FETCH_PURCHASE_ORDER_DETAIL = asyncActionType("FETCH_PURCHASE_ORDER_DETAIL");
export const CREATE_PURCHASE_ORDER = asyncActionType("CREATE_PURCHASE_ORDER");
export const DELETE_PURCHASE_ORDER = asyncActionType("DELETE_PURCHASE_ORDER");
export const CLEAR_PURCHASE_ORDER_DETAIL = "CLEAR_PURCHASE_ORDER_DETAIL";
export const CREATE_MULTIPLE_PURCHASE_ORDER = asyncActionType("CREATE_MULTIPLE_PURCHASE_ORDER");
export const FETCH_MULTIPLE_PURCHASE_ORDER = asyncActionType("FETCH_MULTIPLE_PURCHASE_ORDER");
export const CREATE_PURCHASE_ORDER_ITEM_LABEL = asyncActionType("CREATE_PURCHASE_ORDER_ITEM_LABEL");
export const DELETE_PURCHASE_ORDER_ITEM_LABEL = asyncActionType("DELETE_PURCHASE_ORDER_ITEM_LABEL");
